export const EMR_PATIENTS_RETRIEVE_REQUESTED = 'EMR_PATIENTS_RETRIEVE_REQUESTED';
export const EMR_PATIENTS_RETRIEVE_SUCCEED = 'EMR_PATIENTS_RETRIEVE_SUCCEED';
export const EMR_PATIENTS_RETRIEVE_FAILED = 'EMR_PATIENTS_RETRIEVE_FAILED';

export const EMR_CLINIC_CHANGE = 'EMR_CLINIC_CHANGE';
export const EMR_PATIENT_PAGE_CHANGE = 'EMR_PATIENT_PAGE_CHANGE';

export const EMR_PATIENT_SEARCH_CHANGE = 'EMR_PATIENT_SEARCH_CHANGE';
